/* PetLife – Region y comuna en el carrito (Chile).
   - Muestra Region -> Comuna (346 comunas, sin tildes ni n con tilde: "Nunoa", "Maipu").
   - No deja pasar al pago sin elegir ambas.
   - Guarda la eleccion en el pedido (atributos "Region" y "Comuna") y, al ir al pago,
     intenta dejar region y comuna ya escritas en el formulario de Shopify.
   - El boton "Comprar ahora" de la ficha agrega el producto y lleva al carrito para elegir comuna.
   - Funciona en la pagina del carrito y en el carrito lateral (se vuelve a armar cuando
     el carrito se actualiza). */
(function () {
  // El snippet se usa en el carrito y en el carrito lateral: cargar una sola vez.
  if (window.mtComunaListo) return;
  window.mtComunaListo = true;
  var DATOS = [{"c":"AP","n":"Arica y Parinacota","k":["Arica","Camarones","General Lagos","Putre"]},{"c":"TA","n":"Tarapaca","k":["Alto Hospicio","Camina","Colchane","Huara","Iquique","Pica","Pozo Almonte"]},{"c":"AN","n":"Antofagasta","k":["Antofagasta","Calama","Maria Elena","Mejillones","Ollague","San Pedro de Atacama","Sierra Gorda","Taltal","Tocopilla"]},{"c":"AT","n":"Atacama","k":["Alto del Carmen","Caldera","Chanaral","Copiapo","Diego de Almagro","Freirina","Huasco","Tierra Amarilla","Vallenar"]},{"c":"CO","n":"Coquimbo","k":["Andacollo","Canela","Combarbala","Coquimbo","Illapel","La Higuera","La Serena","Los Vilos","Monte Patria","Ovalle","Paiguano","Punitaqui","Rio Hurtado","Salamanca","Vicuna"]},{"c":"VS","n":"Valparaiso","k":["Algarrobo","Cabildo","Calera","Calle Larga","Cartagena","Casablanca","Catemu","Concon","El Quisco","El Tabo","Hijuelas","Isla de Pascua","Juan Fernandez","La Cruz","La Ligua","Limache","Llaillay","Los Andes","Nogales","Olmue","Panquehue","Papudo","Petorca","Puchuncavi","Putaendo","Quillota","Quilpue","Quintero","Rinconada","San Antonio","San Esteban","San Felipe","Santa Maria","Santo Domingo","Valparaiso","Villa Alemana","Vina del Mar","Zapallar"]},{"c":"RM","n":"Metropolitana de Santiago","k":["Alhue","Buin","Calera de Tango","Cerrillos","Cerro Navia","Colina","Conchali","Curacavi","El Bosque","El Monte","Estacion Central","Huechuraba","Independencia","Isla de Maipo","La Cisterna","La Florida","La Granja","La Pintana","La Reina","Lampa","Las Condes","Lo Barnechea","Lo Espejo","Lo Prado","Macul","Maipu","Maria Pinto","Melipilla","Nunoa","Padre Hurtado","Paine","Pedro Aguirre Cerda","Penaflor","Penalolen","Pirque","Providencia","Pudahuel","Puente Alto","Quilicura","Quinta Normal","Recoleta","Renca","San Bernardo","San Joaquin","San Jose de Maipo","San Miguel","San Pedro","San Ramon","Santiago","Talagante","Tiltil","Vitacura"]},{"c":"LI","n":"O'Higgins","k":["Chepica","Chimbarongo","Codegua","Coinco","Coltauco","Donihue","Graneros","La Estrella","Las Cabras","Litueche","Lolol","Machali","Malloa","Marchihue","Mostazal","Nancagua","Navidad","Olivar","Palmilla","Paredones","Peralillo","Peumo","Pichidegua","Pichilemu","Placilla","Pumanque","Quinta de Tilcoco","Rancagua","Rengo","Requinoa","San Fernando","San Vicente","Santa Cruz"]},{"c":"ML","n":"Maule","k":["Cauquenes","Chanco","Colbun","Constitucion","Curepto","Curico","Empedrado","Hualane","Licanten","Linares","Longavi","Maule","Molina","Parral","Pelarco","Pelluhue","Pencahue","Rauco","Retiro","Rio Claro","Romeral","Sagrada Familia","San Clemente","San Javier","San Rafael","Talca","Teno","Vichuquen","Villa Alegre","Yerbas Buenas"]},{"c":"NB","n":"Nuble","k":["Bulnes","Chillan","Chillan Viejo","Cobquecura","Coelemu","Coihueco","El Carmen","Ninhue","Niquen","Pemuco","Pinto","Portezuelo","Quillon","Quirihue","Ranquil","San Carlos","San Fabian","San Ignacio","San Nicolas","Treguaco","Yungay"]},{"c":"BI","n":"Biobio","k":["Alto Biobio","Antuco","Arauco","Cabrero","Canete","Chiguayante","Concepcion","Contulmo","Coronel","Curanilahue","Florida","Hualpen","Hualqui","Laja","Lebu","Los Alamos","Los Angeles","Lota","Mulchen","Nacimiento","Negrete","Penco","Quilaco","Quilleco","San Pedro de la Paz","San Rosendo","Santa Barbara","Santa Juana","Talcahuano","Tirua","Tome","Tucapel","Yumbel"]},{"c":"AR","n":"Araucania","k":["Angol","Carahue","Cholchol","Collipulli","Cunco","Curacautin","Curarrehue","Ercilla","Freire","Galvarino","Gorbea","Lautaro","Loncoche","Lonquimay","Los Sauces","Lumaco","Melipeuco","Nueva Imperial","Padre las Casas","Perquenco","Pitrufquen","Pucon","Puren","Renaico","Saavedra","Temuco","Teodoro Schmidt","Tolten","Traiguen","Victoria","Vilcun","Villarrica"]},{"c":"LR","n":"Los Rios","k":["Corral","Futrono","La Union","Lago Ranco","Lanco","Los Lagos","Mafil","Mariquina","Paillaco","Panguipulli","Rio Bueno","Valdivia"]},{"c":"LL","n":"Los Lagos","k":["Ancud","Calbuco","Castro","Chaiten","Chonchi","Cochamo","Curaco de Velez","Dalcahue","Fresia","Frutillar","Futaleufu","Hualaihue","Llanquihue","Los Muermos","Maullin","Osorno","Palena","Puerto Montt","Puerto Octay","Puerto Varas","Puqueldon","Purranque","Puyehue","Queilen","Quellon","Quemchi","Quinchao","Rio Negro","San Juan de la Costa","San Pablo"]},{"c":"AI","n":"Aysen","k":["Aisen","Chile Chico","Cisnes","Cochrane","Coihaique","Guaitecas","Lago Verde","O'Higgins","Rio Ibanez","Tortel"]},{"c":"MA","n":"Magallanes","k":["Antartica","Cabo de Hornos (Ex Navarino)","Laguna Blanca","Natales","Porvenir","Primavera","Punta Arenas","Rio Verde","San Gregorio","Timaukel","Torres del Paine"]}];
  var porCodigo = {};
  DATOS.forEach(function (r) { porCodigo[r.c] = r; });

  function opcion(valor, texto) { var o = document.createElement('option'); o.value = valor; o.textContent = texto; return o; }

  function llenarComunas(bloque, guardada) {
    var region = bloque.querySelector('[data-mt-region]');
    var comuna = bloque.querySelector('[data-mt-comuna]');
    var r = porCodigo[region.value];
    comuna.innerHTML = '';
    comuna.appendChild(opcion('', r ? 'Elige tu comuna' : 'Primero elige tu region'));
    comuna.disabled = !r;
    if (!r) return;
    r.k.forEach(function (c) { comuna.appendChild(opcion(c, c)); });
    if (guardada && r.k.indexOf(guardada) > -1) comuna.value = guardada;
  }

  function iniciar(bloque) {
    if (bloque.dataset.mtListo) return;
    bloque.dataset.mtListo = '1';
    var region = bloque.querySelector('[data-mt-region]');
    region.innerHTML = '';
    region.appendChild(opcion('', 'Elige tu region'));
    DATOS.forEach(function (r) { region.appendChild(opcion(r.c, r.n)); });
    var guardadaRegion = bloque.dataset.region || '';
    var cod = '';
    DATOS.forEach(function (r) { if (r.n === guardadaRegion || r.c === guardadaRegion) cod = r.c; });
    region.value = cod;
    llenarComunas(bloque, bloque.dataset.comuna || '');
  }

  function iniciarTodos() { document.querySelectorAll('[data-mt-ubicacion]').forEach(iniciar); }

  function valores(bloque) {
    var r = porCodigo[bloque.querySelector('[data-mt-region]').value];
    var c = bloque.querySelector('[data-mt-comuna]').value;
    return r && c ? { codigo: r.c, region: r.n, comuna: c } : null;
  }

  function guardar(v) {
    return fetch((window.routes && window.routes.cart_update_url ? window.routes.cart_update_url : '/cart/update') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { Region: v ? v.region : '', Comuna: v ? v.comuna : '' } })
    }).catch(function () {});
  }

  function sincronizar(origen) {
    var v = valores(origen);
    document.querySelectorAll('[data-mt-ubicacion]').forEach(function (b) {
      if (b === origen) return;
      b.querySelector('[data-mt-region]').value = v ? v.codigo : origen.querySelector('[data-mt-region]').value;
      llenarComunas(b, v ? v.comuna : '');
    });
    return v;
  }

  function mostrarError(bloque, si) {
    bloque.classList.toggle('is-error', si);
    var e = bloque.querySelector('[data-mt-ubic-error]');
    if (e) e.hidden = !si;
  }

  document.addEventListener('change', function (e) {
    var bloque = e.target.closest('[data-mt-ubicacion]');
    if (!bloque) return;
    if (e.target.matches('[data-mt-region]')) llenarComunas(bloque, '');
    mostrarError(bloque, false);
    guardar(sincronizar(bloque));
  });

  // Boton "Pagar" (carrito y carrito lateral): exige region y comuna.
  document.addEventListener('click', function (e) {
    var boton = e.target.closest('button[name="checkout"], input[name="checkout"]');
    if (!boton) return;
    var bloque = boton.closest('#CartDrawer, #main-cart-footer, form, body').querySelector('[data-mt-ubicacion]') || document.querySelector('[data-mt-ubicacion]');
    if (!bloque) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var v = valores(bloque);
    if (!v) {
      mostrarError(bloque, true);
      bloque.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var vacio = bloque.querySelector('[data-mt-region]').value ? bloque.querySelector('[data-mt-comuna]') : bloque.querySelector('[data-mt-region]');
      setTimeout(function () { vacio.focus(); }, 300);
      return;
    }
    boton.setAttribute('aria-busy', 'true');
    boton.disabled = true;
    guardar(v).then(function () {
      var p = new URLSearchParams();
      p.set('checkout[shipping_address][country]', 'CL');
      p.set('checkout[shipping_address][province]', v.codigo);
      p.set('checkout[shipping_address][city]', v.comuna);
      window.location.href = '/checkout?' + p.toString();
    });
  }, true);

  // Boton "Comprar ahora" de la ficha: iria directo al pago sin pasar por el selector.
  // En vez de eso agrega el producto al carrito y lleva a la pagina del carrito para elegir comuna.
  document.addEventListener('click', function (e) {
    var boton = e.target.closest('.shopify-payment-button__button');
    if (!boton) return;
    var form = boton.closest('form');
    if (!form || !form.querySelector('[name="id"]')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    boton.setAttribute('aria-busy', 'true');
    boton.disabled = true;
    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    }).then(function () {
      window.location.href = (window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '?elegir=comuna';
    }, function () {
      boton.disabled = false;
      boton.removeAttribute('aria-busy');
    });
  }, true);

  // Al llegar desde "Comprar ahora": mostrar el selector y marcar lo que falta.
  function enfocarSiViene() {
    if (!/[?&]elegir=comuna/.test(window.location.search)) return;
    var bloque = document.querySelector('#main-cart-footer [data-mt-ubicacion]');
    if (!bloque || valores(bloque)) return;
    bloque.scrollIntoView({ behavior: 'smooth', block: 'center' });
    var region = bloque.querySelector('[data-mt-region]');
    setTimeout(function () { (region.value ? bloque.querySelector('[data-mt-comuna]') : region).focus(); }, 400);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { iniciarTodos(); enfocarSiViene(); });
  } else { iniciarTodos(); enfocarSiViene(); }
  // El carrito lateral se vuelve a dibujar al agregar productos: armar los selectores nuevos.
  new MutationObserver(function () { iniciarTodos(); }).observe(document.documentElement, { childList: true, subtree: true });
})();
